import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';
import { getContentItemForSlotByName } from '@/data/utils/getContentItemForSlotByName';

export const getPlpPage = (props: IncomingContent): Layout => ({
		name: 'AsideExtendedPlp',
		slots: {
			header: [{ name: 'Header', id: 'header' }],
			first: getContentItemForSlotByName(props, 'first'),
			second: getContentItemForSlotByName(props, 'second'),
			third: getContentItemForSlotByName(props, 'third'),
			fourth: getContentItemForSlotByName(props, 'fourth'),
			fifth: getContentItemForSlotByName(props, 'fifth'),
			sixth: getContentItemForSlotByName(props, 'sixth'),
			footer: [
				{ name: 'Footer', id: 'footer' },
			],
		},
	});
